import type { ComponentType } from "react";
import type { ViewAnswer } from "@nabla/api";
import { entrypoint, type Entrypoint, type ViewProps } from "./entrypoint.ts";
import { viewOf } from "./request.ts";

type Page = "contas" | "pessoas" | "registro" | "regras";
type View<K extends Page> = () => Promise<{ readonly default: ComponentType<ViewProps<ViewAnswer<K>>> }>;
type Query = Parameters<ReturnType<typeof viewOf>>[1];
type Explored = { readonly replaceOn: readonly string[]; readonly query: (query: URLSearchParams) => Query };

export function pageEntry<K extends Page>(id: K, title: string, view: View<K>, explored?: Explored): Entrypoint {
  const read = viewOf(id);
  const data = (_: unknown, query: URLSearchParams) => read({}, explored?.query(query));
  const place = () => ({ title, path: [] });
  return entrypoint({ id, path: `/${id}`, replaceOn: explored?.replaceOn ?? [], data, view, place });
}
